import { isEmptyObject } from 'libs/utils';

const qOperations: object = {
  GET_DASHBOARD_ASSIGNED_ORDER_CONFIRMATIONS: (params: object) => {
    const query = `query GetDashboardOrderConfirmations(
      $pagination: PaginationOptions) {
      assigned: getOrderConfirmationsByCriticalPathStatus(
        pagination: $pagination,
        statusId: 4,
        ), {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          id
           author {
             id
             firstname
             lastname
             email
             firebaseId
           }
           assigned_user {
             id
             firstname
             lastname
             email
             firebaseId
           }
          brand {
             id
             name
             departments {
                 id
                 name
             }
          }
          order_confirmation_drop {
            image_url
            agreed_delivery_date
            critical_path {
              id
              status {
                id
                status
              }
              comment
            }
          }
          department{
              id
              name
          }
          pf_style_number
          createdOn
          modifiedOn
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_DASHBOARD_INCOMPLETE_ORDER_CONFIRMATIONS: (params: object) => {
    const query = `query GetDashboardOrderConfirmations(
      $pagination: PaginationOptions) {
      incomplete:getOrderConfirmations(
        pagination: $pagination,
        statusId: 3) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
            id
            status{
              id
              status
            }
           author {
             id
             firstname
             lastname
              email
             firebaseId
           }
           assigned_user {
             id
             firstname
             lastname
              email
             firebaseId
           }
          brand {
             id
             name
             departments {
                 id
                 name
             }
          }
          order_confirmation_drop {
            image_url
            agreed_delivery_date
            critical_path {
              id
              status {
                id
                status
              }
              comment
            }
          }
          department{
              id
              name
          }
          pf_style_number
          createdOn
          modifiedOn
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_DASHBOARD_COMPLETE_ORDER_CONFIRMATIONS: (params: object) => {
    const query = `query GetDashboardOrderConfirmations(
      $pagination: PaginationOptions) {
      complete:getOrderConfirmations(
        pagination: $pagination,
        statusId: 2) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
            id
            status{
              id
              status
            }
           author {
             id
             firstname
             lastname
              email
             firebaseId
           }
           assigned_user {
             id
             firstname
             lastname
              email
             firebaseId
           }
          brand {
             id
             name
             departments {
                 id
                 name
             }
          }
          order_confirmation_drop {
            image_url
            agreed_delivery_date
            critical_path {
              id
              status {
                id
                status
              }
              comment
            }
          }
          department{
              id
              name
          }
          pf_style_number
          createdOn
          modifiedOn
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_DASHBOARD_ASSIGNED_ORDER_CONFIRMATIONS_V2: (params: object) => {
    const query = `query GetDashboardOrderConfirmations(
      $pagination: PaginationOptions) {
      assigned: getOrderConfirmationsByCriticalPathStatusV2(
        pagination: $pagination,
        statusId: 4,
        ), {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          ocId
          ocDropId
          cpId
          criticalPathStatusId
          brandId
          brandName
          deliveryDate
          comment
          styleNumber
          imageUrl
          authorId
          assignedUserId
          modifiedBy
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_DASHBOARD_INCOMPLETE_ORDER_CONFIRMATIONS_V2: (params: object) => {
    const query = `query GetDashboardOrderConfirmations(
      $pagination: PaginationOptions) {
      incomplete:getOrderConfirmationsV2(
        pagination: $pagination,
        statusId: 3) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          ocId
          ocDropId
          cpId
          criticalPathStatusId
          brandId
          brandName
          deliveryDate
          comment
          styleNumber
          imageUrl
          authorId
          assignedUserId
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_DASHBOARD_COMPLETE_ORDER_CONFIRMATIONS_V2: (params: object) => {
    const query = `query GetDashboardOrderConfirmations(
      $pagination: PaginationOptions) {
      complete:getOrderConfirmationsV2(
        pagination: $pagination,
        statusId: 2) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          ocId
          ocDropId
          cpId
          criticalPathStatusId
          brandId
          brandName
          deliveryDate
          comment
          styleNumber
          imageUrl
          authorId
          assignedUserId
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_ORDER_CONFIRMATION_TODOS: (params: object) => {
    const query = `query GetDashboardOrderConfirmations(
      $pagination: PaginationOptions) {
      completeAndIncomplete:getOrderConfirmationsV2(
        pagination: $pagination,
        statusId: 5) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          ocId
          ocDropId
          cpId
          criticalPathStatusId
          brandId
          brandName
          deliveryDate
          comment
          styleNumber
          imageUrl
          authorId
          assignedUserId
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_USER: (params: object) => {
    const query = `query GetUser($id: String) {
            getUser(id: $id) {
              id,
              firstname,
              lastname,
              email,
              title,
              createdOn,
              modifiedOn,
              isActive
            }
        }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_USERS: (params: object) => {
    const query = `query GetUsers ($sort: SortOptions, $pagination: PaginationOptions, $filters: UserFilter) {
          getUsers(sort: $sort, pagination: $pagination, filters: $filters) {
            data {
              id,
              firstname,
              lastname,
              email,
              title,
              createdOn,
              modifiedOn,
              isActive,
              role{
              id,
              roleDescription
              },
              brand {
                id,
                name
              }
              group {
                id,
                name
              }
            }
            pagination {
              currentPageCursor
              nextPageCursor
            }
          }
        }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_USERS_FOR_MANAGEMENT_TABLE: (params: object) => {
    const query = `query GetUsers ($sort: SortOptions, $pagination: PaginationOptions, $filters: UserFilter) {
          getUsersForManagementTable(sort: $sort, pagination: $pagination, filters: $filters) {
            data {
              id,
              firstname,
              lastname,
              email,
              title,
              createdOn,
              modifiedOn,
              isActive,
              role{
              id,
              roleDescription
              },
              brand {
                id,
                name
              }
              group {
                id,
                name
              }
            }
            pagination {
              currentPageCursor
              nextPageCursor
            }
          }
        }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_DEPARTMENTS: (params: object) => {
    const query = `query GetDepartments($sort: SortOptions, $pagination: PaginationOptions) {
      getDepartments(sort: $sort, pagination: $pagination) {
        name
        street_line_1
        surburb
        city
        country
        phone_number
        createdOn
        modifiedOn
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_FACTORIES: (params: object) => {
    const query = `query GetFactories ($sort: SortOptions, $pagination: PaginationOptions) {
        getFactories (sort: $sort, pagination: $pagination) {
          data {
            id
            name
            country
            email_addresses {
              address
            }
          }
          pagination {
            currentPageCursor
            nextPageCursor
          }
        }
     }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_FACTORY_BY_ID: (params: object) => {
    const query = `query getFactoryById ($id: Int) {
        getFactory (id: $id) {
          id
          name
          street_line_1
          street_line_2
          suburb
          postal_code
          city
          country
          email_addresses {
            default
            address
          }
          phone_number
          transport_markup
          discount_on_cost_price
        }
     }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_BRAND_BY_ID: (params: object) => {
    const query = `query getBrandById($id: Int!) {
      getBrand(id: $id) {
        id
        name
        discountFob
        discountLanded
        transportFob
        transportLanded
        vatFob
        vatLanded
        transportMethodFob
        transportMethodLanded
        createdOn
        modifiedOn
        departments {
          id
          name
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_BRANDS: (params: object) => {
    const query = `query GetBrands ($pagination: PaginationOptions) {
      getBrands(pagination: $pagination) {
        data {
          id
          name
          discountFob
          discountLanded
          transportFob
          transportLanded
          vatFob
          vatLanded
          transportMethodFob
          transportMethodLanded
          departments{
            id
            name
          }
        }
        pagination {
          currentPageCursor
          nextPageCursor
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_USER_AUTH_DATA: (params: object) => {
    const query = `query GetUserAuthData($userFirebaseId: String) {
      getUserAuthData(userFirebaseId: $userFirebaseId) {
        id
        brandIds
        brandUserIds
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_GROUP_BY_ID: (params: object) => {
    const query = `query getGroupById($id: Int) {
      getGroup(id: $id) {
        id
        name
        description
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_USER_BY_ID: (params: object) => {
    const query = `query getUserById($id: Int!) {
      getUser(id: $id) {
        id
        firstname
        lastname
        email
        title
        role {
          id
          roleDescription
        },
        group {
          id
          name
        }
        brand {
          id
          name
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_GROUPS: (params: object) => {
    const query = `query GetGroups ($sort: SortOptions, $pagination: PaginationOptions) {
      getGroups(sort: $sort, pagination: $pagination) {
        data {
          id
          name,
          numberOfUsers
        }
        pagination {
          currentPageCursor
          nextPageCursor
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_BLANK_STOCK_PROFILE_BY_ID: (params: object) => {
    const query = `query getBlankStockProfileById($id: Int) {
      getBlankStockProfile(id: $id) {
        id
        brand_name
        style_colour {
          name
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_BLANK_STOCK_PROFILES: (params: object) => {
    const query = `query GetBlankStockProfiles ($sort: SortOptions, $pagination: PaginationOptions) {
      getBlankStockProfiles(sort: $sort, pagination: $pagination) {
        data {
          id
          brand_name
          style_colour {
            name
          }
        }
        pagination {
          currentPageCursor
          nextPageCursor
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_COMPLETE_ORDER_CONFIRMATIONS: (params: object) => {
    const query = `query GetOrderConfirmations ($sort: SortOptions, $pagination: PaginationOptions, $filters: OrderConfirmationFilter) {
      complete:getOrderConfirmations(sort: $sort, pagination: $pagination, filters: $filters) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        orderConfirmations {
          id
          brand {
            id
            name
            departments {
              id
              name
            }
          }
          department
          pf_style_number
          createdOn
          modifiedOn
          author {
            firstname
            lastname
          }
          assigned_user {
            firstname
            lastname
          }
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_ORDER_CONFIRMATION: (params: object) => {
    const query = `query GetOrderConfirmations ($id: Int!) {
      getOrderConfirmation(id: $id) {
        id
        uploaded_po_file
        brand {
          id
          name
          transportFob
          transportLanded
          vatFob
          vatLanded
          discountFob
          discountLanded
          departments {
            id
            name
          }
        }
        department{
          id
          name
        }
        pf_style_number
        createdOn
        modifiedOn
        author {
          id
          firstname
          lastname
          email
        }
        assigned_user {
          id
          firstname
          lastname
          email
        }
        factory_1 {
          id
          name
          street_line_1
          city
          country
          phone_number
        }
        factory_2 {
          id
          name
          street_line_1
          city
          country
          phone_number
        }
        status  {
          id
          status
        }
        country_of_production
        sales_price_currency
        cost_price_currency
        transport_method
        shape
        brand_ref_number_1
        brand_ref_number_2
        fabric_weight
        fabric_weight_sample
        fabric_composition
        fabric_composition_sample
        amended_count
        transport_method
        print_type
        print_type_sample
        notes
        no_of_print_moulds
        wash
        wash_sample
        trims
        trims_sample
        fit_stage
        sales_price
        cost_price
        transport
        duty_tariff
        drops_to_delete {
          id
        }
        order_confirmation_drop {
          id
          image_url
          stock_total_quantity
          critical_path {
            id
            test_report
            status{
              id
              status
            }
            delivered_quantity
            labels_ordered
            comment
            po_sent
            revised_collection_date
            createdOn
            modifiedOn
          }
          description
          color
          blank_garment
          labels_other
          other
          embellishments_trims
          print
          washing
          packaging_labelling_processing
          license_fee
          pantone_ref
          agreed_delivery_date
          factory_exit_date
          createdOn
          modifiedOn
          blank_stock_order {
            id
            pf_style_number
            delivery_destination {
              id
              name
              street_line_1
              city
              country
              phone_number
            }
            total_quantity
            avg_price_per_unit
            createdOn
            modifiedOn
            blank_stock_order_drop {
              id
              status{
                id
                status
              }
              stock_order_ref
              stock_cost_price
              is_preexisting_stock
              blank_supplier {
              id
              name
              }
              stock_order_quantity {
                id
                xs
                youth_s
                s
                m
                youth_m
                l
                youth_l
                xl
                youth_xl
                xxl
                xxxl
                xxxxl
                xxxxxl
              }
              date_ordered
              stock_delivery_date
              blank_color
              blank_type
            }
          }
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_ACTIVITY_LOGS: (params: object) => {
    const query = `query GetActivityLogs ($sort: SortOptions, $pagination: PaginationOptions, $filters: ActivityLogFilter) {
      getActivityLogs(sort: $sort, pagination: $pagination, filters: $filters) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          id
          changed_field
          field_default_value
          field_new_value
          author {
            id
            firstname
            lastname
            email
          }
          assigned_user {
            id
            firstname
            lastname
            email
          }
          createdOn
          model_kind
          model_id
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_ORDER_CONFIRMATIONS_BY_CRITICAL_PATH_STATUS: (params: object) => {
    const query = `query GetOrderConfirmationsByCriticalPathStatus ($pagination: PaginationOptions) {
      getOrderConfirmationsByCriticalPath(pagination: $pagination) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          id
          author {
            id
            firstname
            lastname
            email
          }
          assigned_user {
            id
            firstname
            lastname
            email
          }
          brand {
            id
            name
            departments {
              id
              name
            }
            discountFob
            discountLanded
            transportFob
            transportLanded
            vatFob
            vatLanded
          }
          factory_1 {
            id
            name
            street_line_1
            city
            country
            phone_number
          }
          factory_2 {
            id
            name
            street_line_1
            city
            country
            phone_number
          }
          department{
            id
            name
          }
          status{
            id
            status
          }
          pf_style_number
          country_of_production
          sales_price_currency
          cost_price_currency
          transport_method
          shape
          brand_ref_number_1
          brand_ref_number_2
          fabric_weight
          fabric_weight_sample
          fabric_composition
          fabric_composition_sample
          transport_method
          print_type
          print_type_sample
          notes
          uploaded_po_file
          no_of_print_moulds
          wash
          wash_sample
          trims
          trims_sample
          fit_stage
          sales_price
          cost_price
          transport
          duty_tariff
          createdOn
          modifiedOn
          order_confirmation_drop {
            id
            image_url
            description
            stock_total_quantity
            blank_stock_order {
              id
              pf_style_number
              delivery_destination {
                id
                name
                street_line_1
                city
                country
                phone_number
              }
              total_quantity
              avg_price_per_unit
              createdOn
              modifiedOn
              blank_stock_order_drop {
                id
                status{
                   id
                   status
                }
                is_preexisting_stock
                stock_order_ref
                stock_cost_price
                blank_supplier {
                id
                name
                }
                stock_order_quantity {
                  xs
                  youth_s
                  s
                  m
                  youth_m
                  l
                  youth_l
                  xl
                  youth_xl
                  xxl
                  xxxl
                  xxxxl
                  xxxxxl
                }
                date_ordered
                stock_delivery_date
                blank_color
                blank_type
              }
            }
            color
            blank_garment
            labels_other
            other
            embellishments_trims
            print
            washing
            license_fee
            packaging_labelling_processing
            pantone_ref
            agreed_delivery_date
            factory_exit_date
            createdOn
            modifiedOn
            critical_path {
              id
              test_report
              status {
                id
                status
              }
              delivered_quantity
              labels_ordered
              comment
              po_sent
              collection_date
              revised_collection_date
              grounded {
                date_payment_expected
                date_of_payment
                invoice_number
                factory_1_paid
                factory_1_invoice_number
                factory_2_paid
                factory_2_invoice_number
                comment
              }
              createdOn
              modifiedOn
              development_sample_date
              development_sample_r_a
              production_sample_date
              production_sample_r_a
            }
          }
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_CRITICAL_PATH_TABLE_DATA: (params: object) => {
    const query = `query GetCriticalPathTableData ($pagination: PaginationOptions,$filters: FilterOptions) {
      getCriticalPathTableData(pagination: $pagination,filters: $filters) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          ocId
          ocDropId
          cpId
          bsoId
          brandName
          brandId
          departmentName
          deliveryDate
          styleNumber
          brandReference1
          brandReference2
          deliveredQuantity
          description
          descriptionColor
          bsoTotalQuantity
          ocDropTotalQuantity
          factory1Name
          factory2Name
          color
          criticalPathStatusId
          comment
          factoryExitDate
          revisedCollectionDate
          poSent
          labelsOrdered
          testReport
          developmentSampleDate
          developmentSampleStatus
          productionSampleDate
          productionSampleStatus
          numberOfRecords
          hasStockOrderQuantities
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_ORDER_CONFIRMATIONS_FOR_TABLE: (params: object) => {
    const query = `query GetOrderConfirmationsForTable($pagination: PaginationOptions,$filters: FilterOptions, $statusId: Int!) {
      getOrderConfirmationsForTable(pagination: $pagination,filters: $filters, statusId:$statusId) {
          pagination {
          nextPageCursor
          currentPageCursor
          }
          data {
            id
            brandId
            brand
            department
            pf_style_number
            dateCreated
            dateUpdated
            createdBy
            assignedTo
            lastUpdatedBy
            assigned_user_id
            author_id
          }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: 'GetOrderConfirmationsForTable',
        query,
      }
      : {
        operationName: 'GetOrderConfirmationsForTable',
        query,
        variables: params,
      };
  },
  GET_ORDER_CONFIRMATIONS_FOR_EXPORT: (params: object) => {
    const query = `query GetOrderConfirmationsForExport($filters: FilterOptions, $statusId: Int!) {
      getOrderConfirmationsForExport(filters: $filters, statusId:$statusId) {
            id
            brandId
            brand
            department
            pf_style_number
            dateCreated
            dateUpdated
            createdBy
            assignedTo
            lastUpdatedBy
            assigned_user_id
            author_id
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: 'GetOrderConfirmationsForExport',
        query,
      }
      : {
        operationName: 'GetOrderConfirmationsForExport',
        query,
        variables: params,
      };
  },
  GET_CRITICAL_PATH_FOR_EXPORT: (params: object) => {
    const query = `query GetCriticalPathForExport($filters: FilterOptions) {
      getCriticalPathForExport(filters: $filters) {
        ocId
        ocDropId
        cpId
        bsoId
        brandName
        brandId
        departmentName
        deliveryDate
        styleNumber
        brandReference1
        brandReference2
        deliveredQuantity
        description
        descriptionColor
        bsoTotalQuantity
        ocDropTotalQuantity
        factory1Name
        factory2Name
        color
        criticalPathStatusId
        comment
        factoryExitDate
        revisedCollectionDate
        poSent
        labelsOrdered
        testReport
        developmentSampleDate
        developmentSampleStatus
        productionSampleDate
        productionSampleStatus
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: 'GetCriticalPathForExport',
        query,
      }
      : {
        operationName: 'GetCriticalPathForExport',
        query,
        variables: params,
      };
  },
  GET_DISPATCHED_STOCK_FOR_EXPORT: (params: object) => {
    const query = `query GetDispatchedStockForExport($filters: FilterOptions) {
      getDispatchedStockForExport(filters: $filters) {
        ocId
        ocDropId
        cpId
        styleNumber
        agreedDeliveryDate
        revisedCollectionDate
        brandRef1
        brandRef2
        transport
        transportMethod
        brandId
        brandName
        brandVatFob
        brandVatLanded
        brandDiscountFob
        brandDiscountLanded
        brandTransportFob
        brandTransportLanded
        departmentId
        departmentName
        costPrice
        salesPrice
        costPriceCurrency
        salesPriceCurrency
        deliveredQuantity
        description
        ocDropColor
        cpStatus
        comment
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: 'GetDispatchedStockForExport',
        query,
      }
      : {
        operationName: 'GetDispatchedStockForExport',
        query,
        variables: params,
      };
  },
  GET_ORDER_CONFIRMATIONS: (params: object) => {
    const query = `query GetOrderConfirmations($pagination: PaginationOptions, $statusId: Int){
          getOrderConfirmations(pagination: $pagination, statusId:$statusId){
            pagination{
            nextPageCursor
            currentPageCursor
            }
            data {
              id
              createdOn
              modifiedOn
              author {
                id
                firstname
                lastname
                email
              }
              assigned_user {
                id
                firstname
                lastname
                email
              }
              brand {
                id
                name
              }
              factory_1 {
                id
                name
                street_line_1
                city
                country
                phone_number
              }
              factory_2 {
                id
                name
                street_line_1
                city
                country
                phone_number
              }
              department{
                id
                name
              }
              status  {
                id
                status
              }
              pf_style_number
              country_of_production
              sales_price_currency
              cost_price_currency
              transport_method
              shape
              brand_ref_number_1
              brand_ref_number_2
              fabric_weight
              fabric_weight_sample
              fabric_composition
              fabric_composition_sample
              transport_method
              print_type
              print_type_sample
              notes
              no_of_print_moulds
              wash
              wash_sample
              trims
              trims_sample
              fit_stage
              sales_price
              cost_price
              transport
              duty_tariff
              drops_to_delete {
                id
              }
              order_confirmation_drop {
                id
                image_url
                critical_path {
                  id
                  test_report
                  status{
                    id
                    status
                  }
                  delivered_quantity
                  labels_ordered
                  comment
                  po_sent
                  revised_collection_date
                  createdOn
                  modifiedOn
                }
                description
                color
                blank_garment
                labels_other
                other
                embellishments_trims
                print
                washing
                license_fee
                packaging_labelling_processing
                pantone_ref
                agreed_delivery_date
                factory_exit_date
                createdOn
                modifiedOn
                blank_stock_order {
                  id
                  pf_style_number
                  delivery_destination {
                    id
                    name
                    street_line_1
                    city
                    country
                    phone_number
                  }
                  total_quantity
                  avg_price_per_unit
                  createdOn
                  modifiedOn
                  blank_stock_order_drop {
                    id
                    status{
                      id
                      status
                    }
                    stock_order_ref
                    stock_cost_price
                    is_preexisting_stock
                    blank_supplier {
                    id
                    name
                    }
                    stock_order_quantity {
                      xs
                      youth_s
                      s
                      m
                      youth_m
                      l
                      youth_l
                      xl
                      youth_xl
                      xxl
                      xxxl
                      xxxxl
                      xxxxxl
                    }
                    date_ordered
                    stock_delivery_date
                    blank_color
                    blank_type
                  }

                }

                }
            }
          }
        }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  // todo: splitgetBlankStockOrderDrops
  GET_LIVE_ASSIGNED_TO_OC_ORDER_CONFIRMATIONS_AND_BLANK_TYPES: (params: object) => {
    const query = `query GetLiveAssignedOrderConfirmationsAndBlankTypes ($pagination: PaginationOptions, $statusId: Int, $altPagination: PaginationOptions) {
      getBlankStockProfiles(pagination: $altPagination) {
        data {
          id
          brand_name
          style_colour {
            name
          }
        }
      }
      getOrderConfirmations(pagination: $pagination, statusId: $statusId) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          id
          status{
            id
            status
          }
          factory_1 {
            name
          }
          pf_style_number
          sales_price_currency
          order_confirmation_drop {
            id
            stock_total_quantity
            blank_garment
            license_fee
            createdOn
            modifiedOn
            blank_stock_order {
              id
              pf_style_number
              total_quantity
              avg_price_per_unit
              blank_stock_order_drop {
                id
                status {
                   id
                   status
                }
                is_preexisting_stock
                stock_order_ref
                stock_cost_price
                blank_supplier {
                id
                name
                }
                stock_order_quantity {
                  xs
                  youth_s
                  s
                  m
                  youth_m
                  l
                  youth_l
                  xl
                  youth_xl
                  xxl
                  xxxl
                  xxxxl
                  xxxxxl
                }
                date_ordered
                blank_color
                blank_type
              }
            }
            critical_path {
              id
              delivered_quantity
              comment
              status {
              id
              status
              }
            }
          }
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_LIVE_ASSIGNED_STOCK_TABLE_DATA: (params: object) => {
    const query = `query GetLiveAssignedTableData ($pagination: PaginationOptions, $statusId: Int!,$filters: FilterOptions) {
      getLiveAssignedTableData (pagination: $pagination, statusId: $statusId, filters: $filters) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          bsoId
          bsodId
          ocStatusId
          ocId
          ocDropId
          cpId
          cpStatusId
          avgUnitPrice
          blankType
          blankTypeBrandName
          blankColor
          blankGarment
          dateOrdered
          orderedQuantity
          deliveredQuantity
          comment
          salesPriceCurrency
          factory1Name
          styleNumber
          createdOn
          modifiedOn
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_GROUNDED_DATA: (params: object) => {
    const query = `query GetGroundedData ($pagination: PaginationOptions, $filters: FilterOptions) {
      getGroundedData(pagination: $pagination, filters: $filters) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          ocId
          ocDropId
          cpId
          styleNumber
          agreedDeliveryDate
          collectionDate
          revisedCollectionDate
          brandRef1
          brandRef2
          transport
          transportMethod
          brandId
          brandName
          brandVatFob
          brandVatLanded
          brandDiscountFob
          brandDiscountLanded
          brandTransportFob
          brandTransportLanded
          departmentId
          departmentName
          costPrice
          salesPrice
          costPriceCurrency
          salesPriceCurrency
          deliveredQuantity
          description
          ocDropColor
          cpStatus
          comment
          poSent
          labelsOrdered
          testReport
          factory1Paid
          factory2Paid
          factory1InvoiceNumber
          factory2InvoiceNumber
          groundedComment
          groundedDateOfPayment
          groundedInvoiceNumber
          groundedDatePaymentExpected
          numberOfRecords
          factory1Name
          factory2Name
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_DISPATCHED_STOCK_ORDER_CONFIRMATIONS: (params: object) => {
    const query = `query GetDispatchedStockOrderConfirmations ($pagination: PaginationOptions, $filters: FilterOptions) {
      getDispatchedStock(pagination: $pagination, filters: $filters) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          ocId
          ocDropId
          cpId
          styleNumber
          agreedDeliveryDate
          revisedCollectionDate
          brandRef1
          brandRef2
          transport
          transportMethod
          brandId
          brandName
          brandVatFob
          brandVatLanded
          brandDiscountFob
          brandDiscountLanded
          brandTransportFob
          brandTransportLanded
          departmentId
          departmentName
          costPrice
          salesPrice
          costPriceCurrency
          salesPriceCurrency
          deliveredQuantity
          description
          ocDropColor
          cpStatus
          comment
          numberOfRecords
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_CREATE_STOCK_METADATA: (params: object) => {
    const query = `query GetCreateStockMetadata {
      getFactories {
        data {
          id
          name
          country
          email_addresses {
            address
          }
        }
        pagination {
          currentPageCursor
          nextPageCursor
        }
      }
      getBlankStockProfiles {
        data {
          id
          brand_name
          style_colour {
            name
          }
        }
        pagination {
          currentPageCursor
          nextPageCursor
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_STOCK_ITEM_DATA: (params: object) => {
    const query = `query GetStockItemData ($id: Int!) {
      getBlankStockOrderDrop(id: $id) {
        id
        blank_color
        blank_supplier {
        id
        name
        }
        blank_type
        date_ordered
        is_preexisting_stock
        stock_cost_price
        stock_delivery_date
        status {
          id
          status
        }
        deductions {
          oc_id
          oc_author {
            id
            firstname
            lastname
          }
          oc_assigned_user {
            id
            firstname
            lastname
          }
          oc_createdOn
          oc_modifiedOn
          bsod_date_ordered
          bsod_stock_cost_price
          bsod_stock_order_quantity {
            xs
            youth_s
            s
            m
            youth_m
            l
            youth_l
            xl
            youth_xl
            xxl
            xxxl
            xxxxl
            xxxxxl
          }
          bsod_createdOn
          bsod_modifiedOn
        }
        stock_order_quantity {
          id
          xs
          youth_s
          s
          m
          youth_m
          l
          youth_l
          xl
          youth_xl
          xxl
          xxxl
          xxxxl
          xxxxxl
        }
        stock_order_ref
      }
      getFactories {
        data {
          id
          name
          country
          email_addresses {
            address
          }
        }
        pagination {
          currentPageCursor
          nextPageCursor
        }
      }
      getBlankStockProfiles {
        data {
          id
          brand_name
          style_colour {
            name
          }
        }
        pagination {
          currentPageCursor
          nextPageCursor
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_BLANK_STOCK_ORDER_DROP: (params: object) => {
    const query = `query GetBlankStockOrderDropById ($id: Int!) {
      getBlankStockOrderDrop(id: $id) {
        id
        blank_color
        blank_supplier {
        id
        name
        }
        blank_type
        date_ordered
        is_preexisting_stock
        stock_cost_price
        stock_delivery_date
        status {
        id
        status
        }
        deductions {
          oc_id
          oc_author {
            id
            firstname
            lastname
          }
          oc_assigned_user {
            id
            firstname
            lastname
          }
          oc_createdOn
          oc_modifiedOn
          bsod_date_ordered
          bsod_stock_cost_price
          bsod_stock_order_quantity {
            xs
            youth_s
            s
            m
            youth_m
            l
            youth_l
            xl
            youth_xl
            xxl
            xxxl
            xxxxl
            xxxxxl
          }
          bsod_createdOn
          bsod_modifiedOn
        }
        stock_order_quantity {
          xs
          youth_s
          s
          m
          youth_m
          l
          youth_l
          xl
          youth_xl
          xxl
          xxxl
          xxxxl
          xxxxxl
        }
        stock_order_ref
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_BLANK_STOCK_ORDER_FORM_METADATA: (params: object) => {
    const query = `query GetBlankStockOrderFormMetadata($pagination: PaginationOptions, $filters: BlankStockOrderDropFilter) {
      getBlankStockOrderDrops(pagination: $pagination, filters: $filters) {
        pagination {
          nextPageCursor
          currentPageCursor
        }
        data {
          id
          stock_order_ref
           status {
            id
            status
            }
          deductions {
            bsod_stock_order_quantity {
              xs
              youth_s
              s
              m
              youth_m
              l
              youth_l
              xl
              youth_xl
              xxl
              xxxl
              xxxxl
              xxxxxl
            }
          }
          stock_order_quantity {
            xs
            youth_s
            s
            m
            youth_m
            l
            youth_l
            xl
            youth_xl
            xxl
            xxxl
            xxxxl
            xxxxxl
          }
        }
      }
      getFactories {
        data {
          id
          name
          country
          email_addresses {
            address
          }
        }
        pagination {
          currentPageCursor
          nextPageCursor
        }
      }
      getBlankStockProfiles {
        data {
          id
          brand_name
          style_colour {
            name
          }
        }
        pagination {
          currentPageCursor
          nextPageCursor
        }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  // todo: split (consider existing/generic getFactories and getBlankStockProfiles)
  GET_INVENTORY_UNASSIGNED_ITEMS_AND_METADATA: (params: object) => {
    const query = `query GetBlankStockOrderDrops ($pagination: PaginationOptions, $altPagination: PaginationOptions, $filters: BlankStockOrderDropFilter) {
        getBlankStockProfiles(pagination: $altPagination) {
          data {
            id
            brand_name
          }
        }
        getFactories (pagination: $altPagination) {
          data {
            id
            name
          }
        }
        getBlankStockOrderDrops(pagination: $pagination, filters: $filters) {
          pagination {
            nextPageCursor
            currentPageCursor
          }
          data {
            id
            blank_color
            blank_stock_order_id
            blank_supplier {
            id
            name
            }
            blank_type
            date_ordered
            stock_cost_price
            deductions {
              oc_id
              oc_author {
                id
                firstname
                lastname
              }
              oc_assigned_user {
                id
                firstname
                lastname
              }
              oc_createdOn
              oc_modifiedOn
              bsod_date_ordered
              bsod_stock_cost_price
              bsod_stock_order_quantity {
                xs
                youth_s
                s
                m
                youth_m
                l
                youth_l
                xl
                youth_xl
                xxl
                xxxl
                xxxxl
                xxxxxl
              }
              }
            stock_order_quantity {
              xs
              youth_s
              s
              m
              youth_m
              l
              youth_l
              xl
              youth_xl
              xxl
              xxxl
              xxxxl
              xxxxxl
            }
            stock_order_ref
            status {
            id
            status
            }
          }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_INVENTORY_UNASSIGNED_ITEMS: (params: object) => {
    const query = `query GetInventoryUnassignedTableData ($pagination: PaginationOptions, $filters: FilterOptions, $statusId: Int!) {
        getInventoryUnassignedTableData(pagination: $pagination, filters: $filters, statusId: $statusId) {
          pagination {
            nextPageCursor
            currentPageCursor
          }
          data {
            id
            blank_color
            blank_stock_order_id
            blank_supplier {
              id
              name
            }
            blank_type
            blank_type_name
            date_ordered
            stock_cost_price
            deductions {
              oc_id
              oc_author {
                id
                firstname
                lastname
              }
              oc_assigned_user {
                id
                firstname
                lastname
              }
              oc_createdOn
              oc_modifiedOn
              bsod_date_ordered
              bsod_stock_cost_price
              bsod_stock_order_quantity {
                xs
                youth_s
                s
                m
                youth_m
                l
                youth_l
                xl
                youth_xl
                xxl
                xxxl
                xxxxl
                xxxxxl
              }
            }
            stock_order_quantity {
              xs
              youth_s
              s
              m
              youth_m
              l
              youth_l
              xl
              youth_xl
              xxl
              xxxl
              xxxxl
              xxxxxl
            }
            stock_order_ref
            status
          }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_BLANK_STOCK_ORDER_DROPS_FOR_BSO: (params: object) => {
    const query = `query GetBlankStockOrderDropsForBSO ($pagination: PaginationOptions, $bsoId: Int!) {
        getBlankStockOrderDropsForBSO(pagination: $pagination, bsoId: $bsoId) {
          pagination {
            nextPageCursor
            currentPageCursor
          }
          data {
            id
            blank_color
            blank_supplier {
              id
              name
            }
            blank_type
            date_ordered
            is_preexisting_stock
            stock_cost_price
            stock_delivery_date
            status {
              id
              status
            }
            deductions {
              oc_id
              oc_author {
                id
                firstname
                lastname
              }
              oc_assigned_user {
                id
                firstname
                lastname
              }
              oc_createdOn
              oc_modifiedOn
              bsod_date_ordered
              bsod_stock_cost_price
              bsod_stock_order_quantity {
                xs
                youth_s
                s
                m
                youth_m
                l
                youth_l
                xl
                youth_xl
                xxl
                xxxl
                xxxxl
                xxxxxl
              }
              bsod_createdOn
              bsod_modifiedOn
            }
            stock_order_quantity {
              id
              xs
              youth_s
              s
              m
              youth_m
              l
              youth_l
              xl
              youth_xl
              xxl
              xxxl
              xxxxl
              xxxxxl
            }
            stock_order_ref
          }
        }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
  GET_BLANK_STOCK_ORDER_DROP_UNASSIGNED_OPTIONS: (params: object) => {
    const query = `query GetBlankStockOrderDrops ($sort: SortOptions, $pagination: PaginationOptions) {
        getBlankStockOrderDrops(sort: $sort, pagination: $pagination, filters: { status: unassigned }) {
          pagination {
            nextPageCursor
            currentPageCursor
          }
          blankStockOrderDrops {
            id
            stock_order_ref
          }
      }
    }`;
    return isEmptyObject(params)
      ? {
        operationName: null,
        query,
      }
      : {
        operationName: null,
        query,
        variables: params,
      };
  },
};
export default qOperations as {
  [key: string]: Function;
};
